<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('shipments.directions')"
    class="direction-filter w-2"
    optional
  >
    <RygenMultiSelect
      :id="inputId"
      v-model="internalValue.directions"
      :options="availableDirections"
      :placeholder="t('shipments.directions')"
      append-to="body"
      display="chip"
      option-label="label"
      option-value="value"
      filter
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { type PropType, ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { mapEnumToTranslatedDropdownValues } from '@rygen/rygen-ui/i18n';
import { Direction } from '@rygen/rygen-ui/model';

import { OrderSearchCriteria, ShipmentSearchCriteria } from '@/model';

import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import RygenMultiSelect from '@rygen/rygen-ui/components/form/RygenMultiSelect.vue';

const internalValue = defineModel({
  type: Object as PropType<OrderSearchCriteria | ShipmentSearchCriteria>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);
const { t } = useI18n();

const availableDirections = ref(
  mapEnumToTranslatedDropdownValues(Direction, 'Direction'),
);
</script>
